import { Button, Form, Input, Layout } from "antd"
import { Link } from "react-router-dom";
import styled from "styled-components";
const { Content } = Layout;

export const Container = styled.div`
    display: flex;
    flex-direction: column;
`
export const XContent = styled(Content)`
    display: flex;
    align-self: center;
    margin: 26px;
    flex-wrap:wrap;
    justify-content: center;
    margin-top: 120px;
    margin-bottom: 120px;
    padding: 0 50px;
     @media only screen and (max-width: 820px) {
       padding: 0px !important;
    }
`

export const SiteLayoutBackground = styled.div`
 display: flex;
 flex-wrap: wrap;
 justify-content: center;
`
export const Left = styled.div`
    width: 46%;
    margin-right: 26px;
     @media only screen and (max-width: 820px) {
       /* width: 80%;
       margin-right: 0;
       margin-bottom: 13px; */
       width: 100%;
    }
    @media only screen and (max-width: 500px) {
        width: 100%;
    }
`
export const Right = styled.div`
    width: 46%;
    margin-left: 26px;
    /* padding: 30px; */
    /* display: flex; */
    /* justify-content: flex-end; */
     @media only screen and (max-width: 820px) {
       /* width: 80%;
       margin-left: 0;
       margin-top: 13px; */
       width: 100%;
    }
    @media only screen and (max-width: 500px) {
        width: 100%;
    }
`
export const LoginBox = styled.div`
   padding: 30px;
   /* width: 550px; */
`
export const SignIn = styled.h4`
   color:#A64FA6;
   font-size:36px;
   @media only screen and (max-width: 500px) {
        font-size:26px;
    }
`
export const TextBox = styled(Input)`
   border-radius: 7px;
`
export const XButton = styled(Button)`
   border-radius: 7px;
`
export const ForgotPassword = styled(Link)`
color:#A64FA6;
   font-size:16px;
       display: flex;
    justify-content: flex-end;
    font-weight:600;
`
export const FormItem = styled(Form.Item)`
 margin-bottom: 14px;
`
export const SignUpDiv = styled.div`
 display: flex;
`
export const SignUpLink = styled(Link)`
    color:#A64FA6;
    font-size:16px;
    font-weight:600;
    margin-left:20px;
`
export const SocialButton = styled(Button)`
        display: flex;
        align-items: center;
        font-size: 14px !important;
        height: 44px !important;
}
`
